import { NgModule } from '@angular/core';
import { RightClickTriggerDirective } from './rightclicktrigger.directive';

@NgModule({
    declarations: [RightClickTriggerDirective],
    exports: [RightClickTriggerDirective]
})
export class RightClickTriggerModule { }